import classNames from 'classnames';
import { AccessesFieldType } from '@lib/utils/accessesManagement';

export default function getAccessListItemContentClassName(
  fieldType: AccessesFieldType,
  styles: Record<string, string>,
  isLocked?: boolean,
): string {
  if (isLocked) {
    return classNames(
      styles.accessListItemContent,
      styles.accessListItemContentRowWithLock,
    );
  }
  if (
    fieldType === AccessesFieldType.FullOptions ||
    fieldType === AccessesFieldType.ShortOptions
  ) {
    return classNames(
      styles.accessListItemContent,
      styles.accessListItemContentRow,
    );
  }
  return classNames(
    styles.accessListItemContent,
    styles.accessListItemContentCol,
  );
}
